const template = require('./sections-articles-template.html');
const DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID = window.config.DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID;

module.exports = function SectionsArticlesDirective(helpCenterService) {
    return {
        restrict: 'E',
        scope: {
            categoryId: '='
        },
        template: template,
        link: function (scope) {
            // Initialize variables
            scope.categories = [];
            scope.sections = [];
            scope.articles = [];
            scope.currentCategory = { name: '' };
            scope.currentSectionName = "";
            const SERVICE_CALLOUT_SECTION_ID = window.config.SERVICE_CALLOUT_SECTION_ID;

            // Set current category name function
            scope.setCurrentCategoryName = function () {
                if (!scope.categoryId || !scope.categories.length) return;

                const selectedCategory = scope.categories.find(category => category.id == scope.categoryId);
                if (selectedCategory) {
                    scope.currentCategory.name = selectedCategory.name;
                }
            };

            // Load all categories
            helpCenterService.getCategories()
                .then(function (categories) {
                    scope.categories = categories;
                    scope.setCurrentCategoryName(); // Set name if categoryId exists
                    scope.$evalAsync();
                })
                .catch(function (error) {
                    console.error("Error loading categories:", error);
                });

            // Watch for category changes
            scope.$watch('categoryId', function (newId) {
                if (!newId) {
                    scope.currentCategory.name = "";
                    scope.currentSectionName = "";
                    scope.sections = [];
                    return;
                }

                // Set current category name
                scope.setCurrentCategoryName();
                scope.cateforyFilter = function (category) {
                    return category.id !== DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID;
                };


                // Load sections for this category
                helpCenterService.getSectionsByCategoryId(newId)
                    .then(function (sections) {
                        // Filter out the Service Callout section
                        scope.sections = sections
                            .filter(section => section.id != SERVICE_CALLOUT_SECTION_ID)
                            .map(section => {
                                section.expanded = true; // Start expanded
                                return section;
                            });
                        // Load articles for each section
                        scope.sections.forEach(section => {
                            helpCenterService.getArticlesBySectionId(section.id)
                                .then(function (articles) {
                                    section.articles = articles;
                                    scope.$evalAsync();
                                });
                        });

                        scope.$evalAsync();
                    })
                    .catch(function (error) {
                        console.error("Error loading sections:", error);
                    });
            });

            // Toggle section and set current section name
            scope.toggleSection = function (section) {
                section.expanded = !section.expanded;
                scope.currentSectionName = section.expanded ? section.name : "";

                if (section.expanded && !section.articles) {
                    helpCenterService.getArticlesBySectionId(section.id)
                        .then(function (articles) {
                            section.articles = articles;
                            scope.$evalAsync();
                        });
                }
            };

            scope.showHelpCenter = function () {
                scope.$parent.isCategorySelected = false;
                scope.$parent.showLandingPageTemplate();
            };

            scope.showArticle = function (article) {
                scope.$parent.showArticle(article);
            };
            scope.categoryFilter = function (category) {
                return category.id != DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID;
            };

        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/sections-articles-directive.js
 **/